"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopWebUrl = void 0;
const useCirrusAuthenticationServer_1 = require("./useCirrusAuthenticationServer");
function useCopWebUrl() {
    const { data } = useCirrusAuthenticationServer_1.useCirrusAuthenticationServer();
    if (!data || !data.dnsname || data.name === 'cop') {
        return 'https://webportal.yanzi.se';
    }
    else if (data.name === 'cncop') {
        return 'https://ifangtang.net';
    }
    else {
        return `https://${data.dnsname}`;
    }
}
exports.useCopWebUrl = useCopWebUrl;
//# sourceMappingURL=useCopWebUrl.js.map